import * as Sentry from '@sentry/browser'
import React from 'react'

interface ErrorBoundaryProps {
  fallback: React.ReactNode
}

interface ErrorBoundaryState {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error(error, errorInfo)
    if (process.env.NODE_ENV === 'production') Sentry.captureException(error)
  }

  render() {
    if (this.state.hasError) {
      return <>{this.props.fallback}</>
    }

    return this.props.children
  }
}
